var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.kwtMode !== 'previewLite' ? _c('div', {
    staticClass: "kwt-toolbar"
  }, [_c('div', {
    class: ['toolbar-row', {
      show: _vm.fullScreenVisible
    }]
  }, [_c('a', {
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleFullscreen($event);
      }
    }
  }, [_c('fullscreen-icon', {
    attrs: {
      "is-fullscreen": _vm.isFullscreen,
      "icon-name": "Fullscreen Toggle"
    }
  })], 1)]), _c('div', {
    class: ['toolbar-row', {
      show: _vm.restartVisible
    }]
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.restartActivity(true);
      }
    }
  }, [_c('restart-icon', {
    attrs: {
      "icon-name": "Restart Activity"
    }
  })], 1)]), _vm.kwtMode !== 'preview' ? _c('div', [_c('div', {
    class: ['toolbar-row', {
      show: _vm.logoutVisible
    }]
  }, [_c('a', {
    staticClass: "pure-button",
    attrs: {
      "href": _vm.logoutUrlWithSession,
      "aria-label": "Log Out",
      "tabindex": "4"
    }
  }, [_c('stop-icon', {
    attrs: {
      "icon-name": "Stop"
    }
  })], 1)]), _c('div', {
    class: ['toolbar-row', {
      show: _vm.videoVisible
    }]
  }, [_c('a', {
    on: {
      "click": _vm.showVideo
    }
  }, [_c('video-icon', {
    attrs: {
      "icon-name": "Play Video"
    }
  })], 1)]), _c('div', {
    class: ['toolbar-row', {
      show: _vm.userProgressVisible
    }]
  }, [_c('a', {
    on: {
      "click": _vm.showProgress
    }
  }, [_c('progress-icon', {
    attrs: {
      "icon-name": "Show Progress"
    }
  })], 1)]), _c('div', {
    class: ['toolbar-row', {
      show: _vm.isCertVisible
    }]
  }, [_c('a', {
    on: {
      "click": _vm.showCert
    }
  }, [_c('certificate-icon', {
    attrs: {
      "icon-name": "Show Certificate"
    }
  })], 1)]), _c('div', {
    class: ['toolbar-row', {
      show: _vm.usernameVisible
    }]
  }, [_c('p', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.username))])]), _c('div', {
    class: ['toolbar-row', 'activity-data', {
      show: _vm.activityDataVisible
    }]
  }, [_c('p', [_vm._v("Week " + _vm._s(_vm.nextWeek))]), _c('p', [_vm._v("#" + _vm._s(_vm.nextASN))])])]) : _vm._e()]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }